import { FeedbotThunk } from '../../store/types'
import { openModalDescriptorSelector } from '../../store/modals/selectors'
import { isSettingsModal, SettingsPopupOpenSection } from '../../store/modals'
import { modalsActions } from '../../store/modals/modalsSlice'

export const switchTo =
  (section: SettingsPopupOpenSection): FeedbotThunk =>
  (dispatch, getState) => {
    const openModalDescriptor = openModalDescriptorSelector(getState())

    if (!isSettingsModal(openModalDescriptor)) {
      return
    }

    // @ts-ignore
    dispatch(modalsActions.openModal({ ...openModalDescriptor, openSection: section }))
  }
